export default __webpack_public_path__ + "static/media/chain-kcc.ca8a2b6e.png";